<template>
    <div :class="['split-bar','direction-'+direction]" @click="toggleSplitBar">
        <span v-if="direction=='right'" class="el-icon-caret-right arrow-icon"></span>
        <span v-else-if="direction=='up'" class="el-icon-caret-top arrow-icon"></span>
        <span v-else-if="direction=='down'" class="el-icon-caret-bottom arrow-icon"></span>
        <span v-else class="el-icon-caret-left arrow-icon"></span>
    </div>
</template>

<script>
    export default {
        name: "SplitBar",
        props:{
            direction:{
                required: true,
                type:String,
                default:'left',
                validator: function (value) {
                    return ['left', 'right', 'up','down','',].indexOf(value) !== -1
                }
            }
        },
        methods:{
            toggleSplitBar(){
                this.$emit('toggle');
            }
        }
    }
</script>

<style lang="scss" scoped>

    .split-bar{
        position: absolute;
        right: -15px;
        top:45%;
        width: 15px;
        height: 50px;
        line-height: 50px;
        background: #66b1ff;
        border: none;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        z-index: 3;
        &.direction-up,&.direction-down{
            width: 200px;
            height: 8px;
            bottom: -4px;
            left:calc(50% - 100px);
            top: auto;
        }
        .arrow-icon{
            color: #fff;
            font-size: 15px;
        }
        &:hover{
            background: #409EFF!important;
        }
    }
</style>
